module.exports = __webpack_public_path__ + "img/ketang_hover.99f75d68.png";